import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormCad } from '../components';
import Swal from 'sweetalert2';
import initialData from './initialData';
import schema from './schema'
import { storeResponsavelTecnico, loadResponsavelTecnicos } from '~/store/modules/responsavel_tecnico/action';

const Create = () => {
  let history = useHistory();
  const [responsavel_tecnico, setResponsavelTecnico] = useState(initialData);
  const [saved, setSaved] = useState(false);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors } = useSelector(({ ResponsavelTecnicoReducer }) => ResponsavelTecnicoReducer);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.save) {
      setSaved(errors.save);
    }
  }, [errors]);

  useEffect(() => {
    if (saved && status_response === 201) {
      Swal.fire('Sucesso', 'Registro salvo com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadResponsavelTecnicos());
        }
      );
    }
  }, [status_response, history, dispatch, saved]);


  const handleClose = () => {
    history.push('/tecnicos/responsavel_tecnico');
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(responsavel_tecnico)) {
      let yup_errors = {};
      schema.validate(responsavel_tecnico, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      await dispatch(storeResponsavelTecnico(responsavel_tecnico));
    }
  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Selecione um Técnico Consultor
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Novo</h2>
          </div>
          <div className="card-body">
            <FormCad
              errors={errorsValidate}
              handleSubmit={handleSubmit}
              responsavel_tecnico={responsavel_tecnico}
              schema={schema}
              setResponsavelTecnico={setResponsavelTecnico}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link
          className="btn btn-default"
          to="/tecnicos/responsavel_tecnico"
        >
          <i className="fa fa-window-close" /> Cancelar
        </Link>
        <button
          className="btn btn-success"
          disabled={!responsavel_tecnico.responsavel_tecnico_id}
          form="form_responsavel_tecnico"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Create;
